/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, Map, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';
import * as Defaults from './defaults';
import { defaultPayload } from './getters';
import {
  UPDATE_PAGE_FILTERS,
  RESET_PAGE_FILTERS,
  FETCH_ENTITY_SCORES_PAGE,
  FETCH_ENTITY_SCORES_PAGE_SUCCESS,
  FETCH_ENTITY_SCORES_PAGE_FAILURE,
  UPDATE_SCORE_SORT_DIRECTION,
  UPDATE_SCORE_SORT_OPTIONS,
  CLEAR_SCORE_SORT_OPTIONS,
} from './action-types.js';
import { type ScoresAction } from './types';

export const scores = (
  state: OrderedMap<string, any> = OrderedMap(),
  action: Action<*>
) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_ENTITY_SCORES_PAGE_SUCCESS:
      const items = fromJS(payload.get('items'))
        .filter(d => d.has('reportId'))
        .toOrderedMap()
        .mapKeys((k, v) => v.get('reportId'));
      return state.merge(items);
    default:
      return state;
  }
};

export const modalOpen = (state: boolean = false, action: Action<any>) => {
  return state;
};

export const loading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
    case FETCH_ENTITY_SCORES_PAGE:
      return true;
    case FETCH_ENTITY_SCORES_PAGE_SUCCESS:
    case FETCH_ENTITY_SCORES_PAGE_FAILURE:
    case RESET_PAGE_FILTERS:
      return false;
    default:
      return state;
  }
};

export const scoreSortOptions = (state: Map<string, any> = Defaults.getDefaultScoreSortOption(), action: Action<any>) => {
  switch(action.type) {
    case UPDATE_SCORE_SORT_OPTIONS:
      return action.payload;
    case CLEAR_SCORE_SORT_OPTIONS:
      return Defaults.getDefaultScoreSortOption();
    default:
      return state;
  }
};

export const scoreSortDirection = (state: Function = Defaults.sortComparators.ASC, action: Action<any>) => {
  switch(action.type) {
    case UPDATE_SCORE_SORT_DIRECTION:
      return action.payload;
    case CLEAR_SCORE_SORT_OPTIONS:
      return Defaults.sortComparators.ASC;
    default:
      return state;
  }
};


const currentQuery = (
  state: Map<string, any> = defaultPayload,
  action: ScoresAction<*>
) => {
  const { type, payload, field } = action;

  switch (type) {
    case UPDATE_PAGE_FILTERS:
      if (!field) {
        // Error message for now until better solution
        console.error("Error updating filter, missing field name or 'all'");
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        const updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case RESET_PAGE_FILTERS:
      return defaultPayload;
    default:
      return state;
  }
};

export default combineReducers({
  sort: combineReducers({
    scores: combineReducers({
      options: scoreSortOptions,
      dir: scoreSortDirection,
    }),
  }),
  scores,
  loading,
  currentQuery,
  modalOpen
});



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/stores.js